import { isModifiedClick } from '../../global/keyboard';

/**
 * Dispatches a cancelable <code>menu-click</code> event from the given host element.
 * Bails out early for modified pointer clicks (Ctrl, Meta, Shift, Alt, non-primary
 * button) and when the host is not connected to the document.
 * @returns {boolean} <code>true</code> when the consumer called
 *   <code>event.preventDefault()</code> on the <code>menu-click</code> event,
 *   indicating that the original browser navigation should be suppressed.
 */
export function dispatchMenuClick(
    host: HTMLElement,
    href: string | undefined,
    originalEvent: Event
): boolean {
    if (isModifiedClick(originalEvent as MouseEvent) || !host.isConnected) {
        return false;
    }

    const menuEvent = new CustomEvent('menu-click', {
        bubbles: true,
        composed: true,
        cancelable: true,
        detail: { href },
    });

    return !host.dispatchEvent(menuEvent);
}
